<template>
  <div class="popular plr">
    <div class="popular_head">
      <div class="ti">{{ text('popular_products') }}</div>
      <!--            <a class="view_all pointer" @click="showPopularProducts">Смотреть все</a>-->
    </div>
    <div class="popular_main">
      <ul v-if="isMobile" class="popular_list">
        <li v-for="product in $store.getters.popularProducts.items.slice(0, 4)">
          <ProductListItem :product="product" :popularPreview="true"/>
        </li>
      </ul>
      <slick
        v-else
        :options="slickOptionsPopular"
        class="popular_list-slider"
        ref="slick"
      >
        <div v-for="product in $store.getters.popularProducts.items.slice(0, 4)">
          <ProductListItem :product="product" :popularPreview="true"/>
        </div>
      </slick>
    </div>
  </div>
</template>

<script>
  import {SET_SELECTED_CATEGORY} from '@/store/mutations.type'
  import ProductListItem from '@/components/ECommerce/Products/ProductListItem'
  import Slick from 'vue-slick'
  import '@/assets/css/slick.css'

  import {isMobile} from 'mobile-device-detect'

  export default {
    name: 'PopularProducts',
    components: {ProductListItem, Slick},
    data() {
      return {
        isMobile: isMobile,
        slickOptionsPopular: {
          autoplay: false,
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: false,
          variableWidth: true,
          centerMode: true,
          centerPadding: '20px',
          focusOnSelect: true,
          arrows: false,
          fade: false,
          rtl: false
        }
      }
    },
    created() {
      if (this.$store.getters.guardCssDirection === 'rtl') {
        this.slickOptionsPopular.rtl = true
      }
    },
    computed: {},
    methods: {
      showPopularProducts() {
        this.$store.commit(SET_SELECTED_CATEGORY, {id: 0, name: null, level: null})
        if (this.$route.name !== 'catalog') {
          this.$router.push({name: 'catalog', params: {token: this.$store.getters.token}})
        }
      }
    }
  }
</script>

<style>
  .popular_list_vertical > li {
    min-width: 170px;
  }

  .slick-slide {
    width: 330px;
    padding: 0 5px 12px;
  }
</style>
